import React, { Component } from 'react';
import { Table, Row, Col, Container } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import PlayAudio from './PlayAudio';

class AllStockNewsFull extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockNewsList: [],
            list: [],
            limit: this.props.limit,
        };
    }

    componentDidMount() {
        ApiService.getAllStockNews(200)
            .then(result1 => {
                console.log('allStockNews', result1);
                this.setState({ stockNewsList: result1 });
            })
            .catch((error) => {
                console.log(error);
            });

        ApiService.getFmpArticles(150)
            .then(result => {
                console.log('Articles', result);
                this.setState({ list: result.content });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            return (
                <tr key={listValue.url + Math.random()}>
                    <td><a href={listValue.url} target="_blank" rel="noreferrer">
                        <img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" />
                    </a>
                    </td>
                    <td style={{ textAlign: 'left' }} >
                        <div><a href={listValue.url} target="_blank" rel="noreferrer">{listValue.title}</a></div>
                        <div style={{ fontSize: '10px' }}>{listValue.publishedDate}&nbsp;&nbsp;<Link style={{ fontSize: '10px', fontWeight: 'bold' }} to={url}>({listValue.symbol})</Link></div>
                        <div style={{ fontSize: '15px' }}>{listValue.text} <PlayAudio text={listValue.text}/></div>
                    </td>
                </tr>
            )
        }
    }

    renderArticleRow(listValue) {
        let symbol = listValue.tickers.replace('NYSE:', '')
            .replace('NASDAQ:', '');
        let content = listValue.content.replace(/<a.*?>.*?<\/a>/ig, '').replace(/<p>/ig, '').replace(/<\/p>/ig, '');
        content = this.capitalizeFirstLetter(content);

        let url = '/chart/' + symbol;
        return (
            <tr key={listValue.url + Math.random()} >
                <td><img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" /></td>
                <td style={{ textAlign: 'left', fontSize: '15px' }} >
                    <div style={{ fontSize: '15px' }}>{listValue.title}</div>
                    <div style={{ fontSize: '10px' }}>{listValue.date}&nbsp;&nbsp;<Link style={{ fontSize: '10px', fontWeight: 'bold' }} to={url}>({symbol})</Link></div>
                    <div style={{ fontSize: '12px' }}>{content} <PlayAudio text={content}/></div>
                </td>
            </tr>
        )
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        let tableRow;
        if (this.state.stockNewsList === undefined || this.state.stockNewsList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            tableRow = this.state.stockNewsList.map(this.renderRow.bind(this));
        }

        let articleTableRow;
        if (this.state.list === null || this.state.list.length <= 0) {
            articleTableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            articleTableRow = this.state.list.map(this.renderArticleRow.bind(this));
        }

        let newsHeader = 'News';
        let articleHeader = 'Articles';
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Latest News, Articles and Blogs</title>
                    <link rel="canonical" href="https://www.vizfm.com/news" />
                    <meta name="description" content="Latest News, Articles and Press releases" />
                </Helmet>
                <Container fluid className="p-2">
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            {newsHeader}
                            <Table bordered striped hover size="xs" responsive>
                                <thead>
                                </thead>
                                <tbody>
                                    {tableRow}
                                </tbody>
                            </Table>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            {articleHeader}
                            <Table bordered striped hover size="xs" responsive>
                                <thead>
                                </thead>
                                <tbody>
                                    {articleTableRow}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default AllStockNewsFull;
